// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '진양제약',
  targetSheetName: '오리지널약품추가(약가인하) (VAT포함)',
  headerRowIndex: 2,
  headerRowCount: 1,
  dataStartRowIndex: 3,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제품명',
    commissionRate: '수수료 (VAT포함)',
  },
  requiredHeaders: [
    'No',
    '제품명',
    '보험코드',
    '보험 약가',
    '성분명',
    '수수료 (VAT포함)',
    '상병코드',
    '상병명',
    '생산구분',
    '생동위탁 구분',
  ],
});
